import { Link } from 'react-router-dom';
import styles from '../sidebar.module.scss';
import { Divider } from '../../ui/divider';
import Heading from '../../ui/heading';
import Phone from '../../ui/icons/phone';
import Email from '../../ui/icons/email';
import { useTranslation } from 'react-i18next';

export const SidebarAuthorization = () => {
    const { t } = useTranslation();
    return (
        <div className={styles.instruction}>
            <div className={styles.item}>
                <Divider />
                <Heading level={3} className={styles.title}>
                    {t('pages.login.instruction')}
                </Heading>
                <Link
                    to="/cabinet-dec-instructions.pdf"
                    target="_blank"
                    className={styles.linkText}
                >
                    {t('pages.login.user_manual_for_the_applicants_profile')}
                </Link>
                <Link
                    to="/cabinet-dec-instructions-eng.pdf"
                    target="_blank"
                    className={styles.linkText}
                >
                    User manual of the Applicant's cabinet
                </Link>
                <Link
                    to="https://www.dec.gov.ua/speczyfikkacziya-ua-m1-ectd/"
                    target="_blank"
                    className={styles.linkText}
                >
                    {t('pages.login.ua_m1_ectd_specification')}
                </Link>
            </div>

            <div className={styles.item}>
                <Divider />
                <Heading level={3} className={styles.title}>
                    {t('pages.login.additional_information')}
                </Heading>
                <p className={styles.notice}>
                    {t(
                        'pages.login.information_regarding_granting_or_restoring_access_to_the_system'
                    )}
                </p>
                <div className={styles.addInfo}>
                    <Link to="tel:+380442021707" className={styles.linkText}>
                        <Phone style={{ marginRight: 10 }} />
                        +380(44) 202-17-07
                    </Link>
                    <Link
                        to="mailto:ectd@dec.gov.ua"
                        className={styles.linkText}
                    >
                        <Email style={{ marginRight: 10 }} />
                        ectd@dec.gov.ua
                    </Link>
                </div>
            </div>
        </div>
    );
};
